import React, { useState } from 'react';
import { TextField, Button, Alert, Link, Stack } from '@mui/material';
import AuthLayout from './components/AuthLayout';

const Register = ({ switchToLogin }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleRequestAccess = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await fetch('/api/request-access', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, company })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess('Account created! Check your email for a temporary password. Use it to login and set your new password.');
    } catch (err) {
      setError(err.message || 'Failed to create account');
    }
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Request access"
      subtitle="Create your account. A temporary password is emailed to you."
      footer={<>Already have an account? <Link component="button" type="button" underline="hover" onClick={switchToLogin} sx={{ color: 'var(--link-on-dark)', fontWeight: 600 }}>Login here</Link></>}
    >
      {success ? (
        <Stack spacing={2}>
          <Alert severity="success">{success}</Alert>
          <Button variant="contained" size="large" onClick={switchToLogin}>Back to login</Button>
        </Stack>
      ) : (
        <form onSubmit={handleRequestAccess}>
          <Stack spacing={2}>
            <TextField fullWidth label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
            <TextField fullWidth type="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <TextField fullWidth label="Company" value={company} onChange={(e) => setCompany(e.target.value)} required />
            {error && <Alert severity="error">{error}</Alert>}
            <Button type="submit" variant="contained" size="large" disabled={loading}>{loading ? 'Submitting…' : 'Request access'}</Button>
          </Stack>
        </form>
      )}
    </AuthLayout>
  );
};

export default Register;
